<script lang="ts">
    import { blur, fade, fly } from 'svelte/transition'
    import { cubicOut, linear } from 'svelte/easing'
    import { faQuestion, faCommentDollar, faPlus, faAngleLeft, faPhone, faSearch, faTimes, faUsers } from '@fortawesome/free-solid-svg-icons'
    import Fa from 'svelte-fa'
    import LabelledButton from './labelled-button.svelte'
    import PersonsProfile from '../persons/persons-profile.svelte'
    import { action, popoverIndex } from './stores'
    import AccountReferral from '../account/account-referral.svelte'
    import AccountSupport from '../account/account-support.svelte'
    import { onDestroy } from 'svelte'
    let step = 0
    let calling = false

    let localAction: ActionButtonInterface = null
    action.subscribe((value) => {
        localAction = value
        showAction()
    })

    let localIndex = 1000
    let index = 1000
    popoverIndex.subscribe((value) => {
        index = value
    })

    function hideAction() {
        step = 0
        window.person(null)
        action.update((_) => null)
        //
        popoverIndex.update((value) => {
            if (value > 1000) index = value - 1
            localIndex = index
            return index
        })
    }

    function showAction() {
        if (localAction) {
            popoverIndex.update((value) => {
                localIndex = index
                index = value + 1
                localIndex = index
                return index
            })
            if (localAction.action === 'person') {
                step = 2
            }
            if (localAction.action === 'help') {
                step = 3
            }
            if (localAction.action === 'referral') {
                step = 4
            }
        }
    }

    function showButtons() {
        step = 1
    }

    // No desktop o menu abre e fecha só pelo ponteiro, e o clique no botão redondo não faz nada:
    // quem está acostumado a clicar acabaria fechando o menu que o próprio hover abriu. No toque não
    // existe hover, então lá o clique alterna — senão o botão ficaria inerte.
    const isTouch = window.api.utils.utils.isMobile() // screen.width <= 900
    let closeTimer = null

    function onMenuEnter() {
        if (isTouch) return
        clearTimeout(closeTimer)
        if (step === 0) step = 1
    }

    function onMenuLeave() {
        if (isTouch || step !== 1) return
        // uma folga curta antes de fechar: sem ela, passar de raspão por uma borda ou atravessar o
        // vão entre dois botões já derrubaria o menu no meio do caminho
        clearTimeout(closeTimer)
        closeTimer = setTimeout(() => {
            if (step === 1) step = 0
        }, 250)
    }

    function onMenuClick() {
        if (!isTouch) return
        step = step === 1 ? 0 : 1
    }

    // as opções do menu; o botão redondo de baixo fica fora da lista porque ele não entra nem sai,
    // é o ponto fixo em volta do qual as outras aparecem
    const menuItems = [
        { label: 'Indique e ganhe', icon: faCommentDollar, action: showReferral },
        { label: 'Suporte', icon: faQuestion, action: showHelp },
    ]
    if (window.store?.token?.permissions?.super || window.store?.token?.permissions?.persons?.show) {
        menuItems.push({ label: 'Pessoas', icon: faUsers, action: showPersons })
    }

    // O balão "Menu" some quando o ponteiro chega perto, abrindo o menu ou não. Ele não recebe
    // ponteiro (senão tapava o conteúdo de baixo), então não dá para usar :hover: medimos a distância
    // do ponteiro até o botão. Uma leitura de rect por quadro, no máximo.
    let pbActEl: HTMLElement = null
    let nearby = false
    let lastMove: MouseEvent = null
    let framePending = false
    const NEARBY_PX = 150

    function onWindowMouseMove(ev: MouseEvent) {
        lastMove = ev
        if (framePending) return
        framePending = true
        requestAnimationFrame(evaluateNearby)
    }

    function evaluateNearby() {
        framePending = false
        const button = pbActEl?.querySelector('.pb-act_toggle button')
        if (!button || !lastMove) {
            nearby = false
            return
        }
        const r = button.getBoundingClientRect()
        const dx = Math.max(r.left - lastMove.clientX, 0, lastMove.clientX - r.right)
        const dy = Math.max(r.top - lastMove.clientY, 0, lastMove.clientY - r.bottom)
        nearby = Math.hypot(dx, dy) < NEARBY_PX
    }

    function showPersons() {
        action.update((_) => {
            return { action: 'person', params: { act: 'search' } }
        })
    }

    function showHelp() {
        action.update((_) => {
            return { action: 'help', params: null }
        })
    }

    function showReferral() {
        action.update((_) => {
            return { action: 'referral', params: null }
        })
    }

    function showSearch() {
        window.person('search')
    }

    onDestroy(() => {
        clearTimeout(closeTimer)
    })
</script>

<svelte:window on:mousemove={onWindowMouseMove} />

<div class="pb" style="z-index: {localIndex};">
    {#if step >= 2}
        <div class="pb-content scroll-dark pb-content-step-{step}" transition:fly={{ duration: 125, easing: linear, y: 200 }}>
            <div class="pb-head">
                <div class="spacer" />
                <button class="pb-head_btn-close" on:click={hideAction}><Fa icon={faTimes} /></button>
            </div>
            {#if step === 4}
                <div class="pb-body pb-body-referral">
                    <AccountReferral></AccountReferral>
                </div>
            {/if}
            {#if step === 3}
                <div class="pb-body pb-body-support">
                    <AccountSupport></AccountSupport>
                </div>
            {/if}
            {#if step === 2}
                <div class="pb-body pb-body-person">
                    <PersonsProfile params={localAction.params} />
                </div>
            {/if}
        </div>
    {:else}
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <div class="pb-act" class:is-nearby={nearby} bind:this={pbActEl} on:mouseenter={onMenuEnter} on:mouseleave={onMenuLeave}>
            {#if step === 1}
                {#each menuItems as item, i (item.label)}
                    <!-- Entram de baixo para cima, uma depois da outra, e saem na ordem inversa.
                         |global é obrigatório aqui: a transição padrão é local e só toca quando o
                         bloco dono do elemento nasce. Estes divs pertencem ao {#each}, que é criado
                         junto com o {#if} acima — para eles quem nasceu foi o bloco pai, e sem
                         |global a entrada simplesmente não acontece. -->
                    <div
                        class="pb-act_item"
                        in:fly|global={{ y: 16, duration: 220, delay: (menuItems.length - 1 - i) * 45, easing: cubicOut }}
                        out:fly|global={{ y: 16, duration: 140, delay: i * 35, easing: cubicOut }}
                    >
                        <LabelledButton on:click={item.action} color="#328866" label={item.label} icon={item.icon} background="#ffffff" />
                    </div>
                {/each}
            {/if}
            <!-- o botão de baixo não entra nem sai: o "+" gira e vira "×" quando o menu está aberto -->
            <div class="pb-act_toggle" class:is-open={step === 1}>
                <LabelledButton class="pb-act_menu" on:click={onMenuClick} color="#328866" label={step === 1 ? '' : 'Menu'} icon={faPlus} background="#ffffff" />
            </div>
        </div>
    {/if}
</div>
{#if step > 1}
    <div class="pb-cover"></div>
{/if}

<style>
    .pb {
        /* ver o bloco de pointer-events lá embaixo */
        pointer-events: none;
        position: absolute;
        bottom: 32px;
        right: 40px;
        display: flex;
        align-items: flex-end;
        flex-direction: column;
        z-index: 999;
    }
    .pb-content {
        /* o container é "transparente" ao mouse (ver .pb abaixo); o painel precisa recebê-lo */
        pointer-events: auto;
        overflow-y: auto;
        height: calc(100vh - 100px);
        flex-grow: 1;
        background-color: #333;
        border-radius: 8px;

        box-shadow: #000000 0px 22px 30px -15px;
        border: 1px solid #11111130;
        margin-bottom: 12px;
        display: flex;
        flex-direction: column;
        width: 1200px;
    }
    .pb-head {
        display: flex;
        flex-shrink: 0;
        overflow: hidden;
    }
    .pb-head button {
        background-color: #444444;
        color: #aaa;
        border: 1px;
        width: 90px;
        height: 45px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .pb-head .pb-head_btn-close {
        width: 45px;
        z-index: 1;
        border-radius: 4px;
        margin-top: 4px;
    }
    .pb-act {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 8px;
    }

    /* O bloco flutuante ocupa um retângulo bem maior que os botões: o vão entre eles e, sobretudo, a
       faixa dos balões de rótulo. Esse retângulo roubava o mouse de quem está embaixo, mesmo sem
       nada desenhado ali. Então o container não recebe ponteiro nenhum e só os botões redondos
       voltam a receber — os balões são enfeite (têm cursor default) e não precisam.
       mouseenter/mouseleave no .pb-act continuam funcionando: entrar num filho que recebe ponteiro
       conta como entrar no container. */
    .pb-act :global(.labelled-button button) {
        pointer-events: auto;
    }

    /* o balão "Menu" sai de cena assim que o ponteiro chega perto (ver evaluateNearby), abrindo o
       menu ou não — ele existe para chamar quem ainda não conhece o botão, não para ficar tapando
       o canto da tela na hora de usar */
    .pb-act :global(.pb-act_menu .box-arrow) {
        transition:
            opacity 0.18s ease,
            transform 0.18s ease;
    }
    .pb-act.is-nearby :global(.pb-act_menu .box-arrow) {
        opacity: 0;
        transform: translateX(10px);
    }

    /* o "+" vira "×" girando, em vez de trocar de ícone de um quadro para o outro */
    .pb-act_toggle :global(button svg) {
        transition: transform 0.25s cubic-bezier(0.34, 1.3, 0.64, 1);
    }
    .pb-act_toggle.is-open :global(button svg) {
        transform: rotate(45deg);
    }

    .pb-body {
        padding: 0px;
        flex-grow: 1;
        display: flex;
    }

    .pb-body-person {
        margin-top: -49px;
    }

    .pb-body-support {
        overflow: hidden;
    }

    .pb-body-referral {
        max-width: 800px;
    }

    .pb-content-step-3 {
        overflow: hidden !important;
    }

    @media (max-width: 900px) {
        .pb {
            right: 24px;
        }
        .pb-content {
            max-width: calc(100vw - 32px);
        }
    }
    @media (max-width: 1199px) {
        .pb-content {
            height: calc(100vh - 100px);
            width: 975px;
        }
    }
</style>
